export default __webpack_public_path__ + "static/media/grid-view-active.6c994cd4.svg";